import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllFornecedorCadastro } from '../service';
import {
  LIST_FORNECEDOR_CADASTRO,
  LIST_FORNECEDOR_CADASTRO_PENDING,
  LIST_FORNECEDOR_CADASTRO_SUCCESS,
  LIST_FORNECEDOR_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllFornecedorCadastro(action) {
  yield put({ type: LIST_FORNECEDOR_CADASTRO_PENDING })

  try {
    const list = yield call(findAllFornecedorCadastro)
    
    yield put({ type: LIST_FORNECEDOR_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_FORNECEDOR_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllFornecedorCadastro() {
  yield takeLatest(LIST_FORNECEDOR_CADASTRO, sagaListAllFornecedorCadastro)
}